module.exports = __webpack_public_path__ + "static/media/RectangleWS.694d17dc.png";